







































































































import { MainNavigationVueGB } from "@/extensions/navigation/MainNavigationVueGB";
import { Component } from "vue-property-decorator";

@Component({
  components: {  }
})
export default class MainNavigation extends MainNavigationVueGB {}
